import { z } from "zod";
export const ZJobType = z.union([
    z.literal("specifiedArticles"),
    z.literal("mlPredictDevices"),
    z.literal("deriveRoomExtraIfcInfo"),
    z.literal("addIfcInfo"), // legacy for old runs
    z.string().regex(/^standardRoom\./, {
        message: 'Must start with "standardRoom."',
    }),
]);
export const ZEnqueueEnrichRoomsRequest = z.object({
    projectNo: z.number().min(1),
    jobTypes: z.array(ZJobType).min(1),
});
export const ZEnqueueEnrichRoomsResponse = z.object({
    queuedBatches: z.number().int().min(0),
    totalRooms: z.number().int().min(0),
});
